export default __webpack_public_path__ + "static/media/roi-dashboard-icon.3b3999f4.svg";